<template>
    <div
        class="Footer"
        :class="{
            'Footer--desktop': !isMobile,
            'Footer--home': $route.path === '/',
            'Footer--results': $route.path === '/calculate_results' || $route.path === '/find_results'
        }"
    >
        <div class="Footer-divider"/>
        <span class="Footer-text">{{ footerText }}</span>
    </div>
</template>
<script>
export default {
    name: 'HempelFooter',
    computed: {
        footerText() {
            return this.translation.footer
        }
    }
}
</script>
